function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#22CD33",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.989,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.121 10.435l2.03 2.335 4.903-5.28"
}));

function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSuccessIcon;